<template>
  <div>
    <div class="list-group">
      <div href="#" class="list-group-item list-group-item-action p-0">
        <div
          class="
            d-flex
            w-100
            justify-content-between
            card-mod
            m-0
            p-2
            mch-title
          "
        >
          <h4 class="mb-1">{{ item.title }}</h4>
        </div>
        <p
          class="mb-1 post-body p-3"
          style="overflow: scroll"
          v-html="item.body"
        ></p>
        <display-meta-data
          :author="item.author"
          :when="item.created_date"
          :users="users"
        />
      </div>
    </div>

    <div class="list-group ml-4">
      <div
        class="list-group-item list-group-item-action"
        v-for="comment in item.comments"
      >
        <comment-account-outline-icon class="pr-2" />
        &nbsp;

        <span class="comment">{{ comment.body }}</span>
        <display-meta-data
          :author="comment.author"
          :when="comment.created_date"
          :users="users"
        />
      </div>
      <div class="list-group-item list-group-item-action p-0">
        <div v-if="comment == null" class="d-flex justify-content-end">
          <button type="button" class="btn btn-link" @click="enableComment">
            Add a Comment
          </button>
        </div>

        <b-input-group v-if="comment != null">
          <b-form-textarea v-model="comment" max-rows="5"></b-form-textarea>
          <b-input-group-append>
            <b-button variant="secondary" @click="addComment(item.id)"
              >Comment
            </b-button>
            <button type="button" class="btn btn-link" @click="cancelComment">
              <span aria-hidden="true">&times;</span>
            </button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import DisplayMetaData from "@/news/feed/DisplayMetaData";
import CommentAccountOutlineIcon from "vue-material-design-icons/CommentAccountOutline";
import * as CONFIG from "../../config.js";

export default {
  props: { item: {}, users: {} },
  components: { DisplayMetaData, CommentAccountOutlineIcon },
  data() {
    return {
      comment: null,
    };
  },
  methods: {
    enableComment() {
      this.comment = "";
    },
    cancelComment() {
      this.comment = null;
    },
    addComment(postId) {
      const comment_body = this.comment;
      if (comment_body.trim() != "") {
        const data = {
          author: this.currentUser.id,
          body: comment_body,
          post: postId,
        };
        const vm = this;

        var root_url = CONFIG.root_url;
        axios
          .request({
            url: `${root_url}/news/comment/`,
            method: "post",
            data: data,
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            console.log(response);
            vm.comment = null;
            vm.item.comments.push(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      token: "AuthModule/token",
    }),
    ...mapGetters("AuthModule", ["currentUser"]),
    posts() {
      return this.optionPostItems;
    },
  },
};
</script>
<style>
.card-mod {
  padding: 20px;
  background-color: #f7f7f7;
  margin-bottom: 20px;
}
.card-mod:hover {
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
}
.comment {
  font-size: 10pt;
}
.post-body {
  font-size: 20pt;
}
.mch-title {
  border-bottom: #ed1c24 2px solid;
}
</style>
